import React, { SyntheticEvent } from 'react';
import { Link, mq } from '~/lib';
import { Button, ButtonProps } from '~/shared/components/Button/Button';
import styled from '@emotion/styled';

export type TCTA = Link & {
    onClick: () => void;
    disabled?: boolean;
    variant?: ButtonProps['variant'];
    orderOnMobile?: number;
    className?: string;
};

export const CTA = styled(
    ({ variant = 'plp', text, onClick, disabled, className, ...rest }: TCTA) => {
        const handleClick = (e: SyntheticEvent) => {
            e.preventDefault();
            e.stopPropagation();
            if (disabled) return;
            if (onClick) {
                onClick();
            }
        };

        return (
            <Button
                variant={variant}
                disabled={disabled}
                onClick={handleClick}
                className={className}
                {...rest}
            >
                {text}
            </Button>
        );
    },
)(({ orderOnMobile }) => ({
    [mq(0, 'md')]: {
        order: orderOnMobile,
    },
}));

export const CTAWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    gap: theme.space[2],
    flexDirection: 'column',

    [mq(0, 'md')]: {
        flexWrap: 'wrap',
        flexDirection: 'row',
        padding: theme.space[3],
    },

    [`${CTA}`]: {
        [mq(0, 'md')]: {
            flex: `1 1 calc(50% - ${theme.space[2]})`,
        },
    },
}));
